<template>
  <button
    v-if="langganan"
    type="button"
    class="langganan-chip"
    :class="`nada-${nadaNya}`"
    :title="`Masa langganan sampai ${panjang}. Klik untuk cara perpanjang.`"
    @click="buka"
  >
    <span class="titik" aria-hidden="true"></span>
    <span v-if="nadaNya === 'habis'">Langganan berakhir {{ pendek }}</span>
    <span v-else-if="nadaNya === 'tenggang'">
      Langganan berakhir {{ pendek }}<span class="sisa"> · lunasi s/d {{ lunasi }}</span>
    </span>
    <span v-else>
      <span class="label">Langganan </span>s/d {{ pendek }}<span v-if="nadaNya !== 'ok'" class="sisa"> · {{ sisa }}</span>
    </span>
  </button>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { nada, tanggalPanjang, tanggalPendek, kalimatSisa, bukaPanduanLangganan } from "@/helper/langganan";

export default {
  name: "LanggananChip",
  computed: {
    langganan() {
      return useAppStore().langganan;
    },
    nadaNya() {
      return nada(this.langganan);
    },
    pendek() {
      return tanggalPendek(this.langganan.berakhir);
    },
    panjang() {
      return tanggalPanjang(this.langganan.berakhir);
    },
    sisa() {
      return kalimatSisa(this.langganan.sisa_hari);
    },
    lunasi() {
      return this.langganan.terkunci_pada ? tanggalPendek(this.langganan.terkunci_pada) : "";
    },
  },
  methods: {
    buka() {
      bukaPanduanLangganan(this.$router);
    },
  },
};
</script>

<style scoped>
.langganan-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  font: 600 13px/1 var(--font-ui);
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  color: var(--bar-ink);
  background: var(--chip-ok-bg);
  border: 1px solid rgba(255, 255, 255, 0.16);
  transition: background-color 140ms ease, transform 140ms var(--ease-out);
}
.langganan-chip:active {
  transform: scale(0.97);
}
@media (hover: hover) and (pointer: fine) {
  .langganan-chip:hover {
    background: rgba(255, 246, 216, 0.24);
  }
}
.titik {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--brand-leaf);
  flex: none;
}
.sisa {
  font-weight: 500;
}
.nada-dekat,
.nada-genting {
  background: var(--brand-sun);
  color: var(--brand-sun-ink);
  border-color: transparent;
}
.nada-dekat .titik,
.nada-genting .titik {
  background: var(--brand-sun-ink);
}
@media (hover: hover) and (pointer: fine) {
  .nada-dekat:hover,
  .nada-genting:hover {
    background: var(--brand-sun-hover);
  }
}
.nada-habis,
.nada-tenggang {
  background: var(--danger-bg);
  color: var(--danger-ink);
  border-color: transparent;
}
.nada-habis .titik,
.nada-tenggang .titik {
  background: var(--danger-ink);
}
@media (max-width: 720px) {
  .sisa,
  .label {
    display: none;
  }
  .langganan-chip {
    padding: 0 10px;
  }
}
</style>
